import React from "react";
import Link, { LinkProps } from "next/link";

import ChevronRightIcon from "./icons/ChevonRightIcon";

type BannerProps = {
  variant?: "bright-blue" | "black-almost";
  headingSmall?: string;
  headingBig: string;
};

const Banner: React.FC<BannerProps & LinkProps> = ({
  variant = "bright-blue",
  headingSmall,
  headingBig,
  ...linkProps
}) => (
  <Link {...linkProps}>
    <a>
      <div className={["banner", variant].join(" ")}>
        <div className="container">
          {headingSmall && <h5>{headingSmall}</h5>}
          <h1>
            {`${headingBig} `}
            <ChevronRightIcon />
          </h1>
        </div>
      </div>
    </a>
  </Link>
);

export default Banner;
